export default __webpack_public_path__ + "static/media/no-bill-back.524bcdee.svg";